import React from 'react'
import { ToCartCommonComponent } from '../to_cart_common/to_cart_common.component'
import { CurFormatComponent } from '../../shared/cur_format/cur_format.component'
import { sharedData } from '../../../models/shared_data'

export class ToCartComponent extends ToCartCommonComponent {

  render() {
    const it = this.props.params
    const price = this.currentPrice()
    const symbol = sharedData.currency_symbol
    if(this.state.inCart > 0)
      return (
        <div>
          <div className="item-show-price">
            <div className="item-show-price__amount">
              { this.needUnitsInfo() &&
                <div className="item-show-price_wrapper">
                  <div className="item-show-price_one">
                  { it.price_one } {symbol}/{ it.price_one_unit }, &nbsp;
                  </div>
                  <CurFormatComponent className="main-price" price={price}/>
                  <span>/{it.price_unit}</span>
                </div>
              }
              { !this.needUnitsInfo() &&
                <CurFormatComponent className="main-price" price={price}/>
              }
            </div>
            <div className="item-show-price-incart">
              <div className="item-show-price-incart__wrapper">
                <a className="down" href="" onClick={this.down}>-</a>
                <span className="item-show-price-incart__count">
                  {this.state.quantity}
                </span>
                <a className="up" href="" onClick={this.up}>+</a>
              </div>

              <a href="/cart" className="btn btn--red item-show-price-incart__to-cart">
                Перейти в корзину
              </a>


            </div>
          </div>

          { it.quants.length > 0 &&
            <div>
              { it.quants.map((q)=>
                (
                  <button className="btn btn--quant btn--mini btn--blue item-show-button__to-cart" onClick={(x)=> this.toCartQuant(q)}>
                    {q.title}
                  </button>
                )
              )}
            </div>
          }

        </div>
      )

      // <div className="item-show-price__title">
      //   В корзине
      // </div>
    return (
      <div>
        <div className="item-show-price">
          <div className="item-show-price__amount">
            { this.needUnitsInfo() &&
              <div className="item-show-price_wrapper">
                <div className="item-show-price_one">
                { it.price_one } {symbol}/{ it.price_one_unit }, &nbsp;
                </div>
                <CurFormatComponent className="main-price" price={price}/>

                <span>/{it.price_unit}</span>
              </div>
            }
            { !this.needUnitsInfo() &&
              <CurFormatComponent className="main-price" price={price}/>
            }
          </div>
          <div className="item-show-button">
            <button className="btn btn--red item-show-button__to-cart"
              onClick={this.toCart}
              >В корзину</button>
          </div>
        </div>
        { it.quants.length > 0 &&
          <div>
            { it.quants.map((q)=>
              (
                <button className="btn btn--quant btn--mini btn--blue item-show-button__to-cart" onClick={(x)=> this.toCartQuant(q)}>
                  {q.title}
                </button>
              )
            )}
          </div>
        }
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./app/javascript/website_default/js/react/cart/to_cart/to_cart.component.jsx